var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52869 3.52775C3.65371 3.40276 3.82325 3.33256 4.00002 3.33256C4.1768 3.33256 4.34634 3.40276 4.47136 3.52775L8 7.05641L11.5287 3.52775C11.5902 3.46407 11.6637 3.41328 11.7451 3.37834C11.8264 3.3434 11.9139 3.32502 12.0024 3.32424C12.0909 3.32348 12.1787 3.34034 12.2607 3.37386C12.3426 3.40738 12.417 3.45689 12.4796 3.51948C12.5422 3.58208 12.5917 3.65651 12.6253 3.73844C12.6587 3.82038 12.6756 3.90816 12.6749 3.99668C12.6741 4.0852 12.6557 4.17268 12.6207 4.25402C12.5858 4.33535 12.535 4.40892 12.4713 4.47041L8.94267 7.99908L12.4713 11.5277C12.5928 11.6535 12.66 11.8219 12.6585 11.9967C12.6569 12.1715 12.5869 12.3387 12.4632 12.4623C12.3396 12.5859 12.1724 12.656 11.9976 12.6575C11.8228 12.6591 11.6544 12.5919 11.5287 12.4704L8 8.94174L4.47136 12.4704C4.34562 12.5919 4.17722 12.6591 4.00242 12.6575C3.82762 12.656 3.66042 12.5859 3.53681 12.4623C3.4132 12.3387 3.34309 12.1715 3.34158 11.9967C3.34006 11.8219 3.40725 11.6535 3.52869 11.5277L7.05734 7.99908L3.52869 4.47041C3.40371 4.3454 3.3335 4.17586 3.3335 3.99908C3.3335 3.8223 3.40371 3.65276 3.52869 3.52775Z",
    fill: "black",
    fillOpacity: 0.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.49621facfb9df7bed3f23c3fe84441d3.svg";
export { ForwardRef as ReactComponent };